import { Box, Separator } from '@betterment/samba-react';

export const NoActivityRow = () => (
  <>
    <Separator css={{ fullWidthWithInset: 'space.300' }} />
    <Box css={{ paddingX: 'space.300', paddingY: 'space.400' }}>No recent activity</Box>
  </>
);
